











import { Component, Vue, Prop } from 'vue-property-decorator';
import CertReqForm from '@/components/forms/CertReqForm.vue';
import { Route, RawLocation } from 'vue-router';
import CertificateForm from '@/classes/CertificateForm';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
]);

@Component({
    components: {
        CertReqForm
    }
})
export default class CertificateRequestFormView extends Vue {
    public $refs!: {
        viewform: CertReqForm
    };

    @Prop() public id!: string | number;
    public beforeRouteUpdate(
        to: Route, from: Route, next: (to?: RawLocation | false | ((vm: Vue) => any) | void) => void) {
            this.$refs.viewform.updateForm();
            next();
    }

    public get uniqueId(): string {
        const certForm: CertificateForm | undefined = this.$store.getters.getCertificateFormById(this.id);
        return (certForm || {} as any).uniqueId || '';
    }
}
